"use client"

import { GameItem } from "@/app/types"

type GameCardProps = {
  item: GameItem
  onClick: () => void
}

export const GameCard = ({ item, onClick }: GameCardProps) => {
  return (
    <div
      onClick={onClick}
      className="flex min-h-[140px] gap-0 overflow-hidden rounded-2xl border-3 bg-white transition-all"
      style={{
        borderColor: "#0092D7",
        cursor: "pointer",
      }}
    >
      <div
        className="w-48 shrink-0 p-6 flex items-center justify-center"
        style={{
          background: "#0092D7",
          borderRadius: "12px 0 0 12px",
        }}
      >
        <div className="scale-[2] text-white">{item.icon}</div>
      </div>

      <div className="flex flex-1 flex-col justify-center px-6 py-4">
        <h3 className="mb-2 text-lg font-bold text-gray-800">{item.title}</h3>
        <p className="text-sm text-gray-600">{item.description}</p>
      </div>
    </div>
  )
}
